// import {checkToken} from '@/assets/service/App';
// import {TOKEN_VALIDATE} from './mutation-types.js';

export default {
  // async tokenValidate({commit, state}, token) {
  //   return new Promise((resolve, reject) => {
  //     checkToken({token}).then(res => {
  //       commit(TOKEN_VALIDATE, res);
  //       resolve(res);
  //     }).catch(err => {
  //       reject(err);
  //     });
  //   });
  // }
}

